import './HomeCertificate.css'
import React, { Component } from 'react';
import { messages, options,severProperties } from './utility/Constants';
import axios from 'axios';
import addHookTo from './AddHookTo';
import HeaderMenu from './HeaderMenu';
import { getToken,getRefreshToken,getLocaleLanguage } from './AuthService';
import { Navigate } from 'react-router';
import { RotatingLines } from "react-loader-spinner";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormattedMessage, IntlProvider } from 'react-intl';
class Information extends Component {
  constructor(props) {
    super(props);
    this.state =
    {
      locale: 'en',
      dataField: [],
      loading: true
    };

    this.handleLanguageChange = this.handleLanguageChange.bind(this);
  }

  componentDidMount() {
    this.setState({ locale: getLocaleLanguage() });
    this.setState({ dataField: '', loading: true });
    this.fetchData();
    /*axios.get("https://mocki.io/v1/b4049563-268c-4408-8997-4e04e6a74e04") 
      .then(response => {
        const dataField = response.data;
        this.setState({ dataField });
      });*/
  }

  fetchData = async () => {
    const token = getRefreshToken(); // Replace with your actual token
    const apiUrl = [severProperties.serverURL,"/applicant/application"].join("");//'http://localhost:8084/applicant/application'; // Replace with your API URL

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Origin': severProperties.serverCORS,
        },
      });
      this.setState({ dataField: response.data, loading: false });
    } catch (error) {
      if(error.message === "Network Error")
        {
            alert("Session Expired or Invalid");
            this.props.navigate('/');
        }
        else
        {
          alert("Session Expired or Invalid");
          this.props.navigate('/');        
        }
    }
  };

  componentWillUnmount() {
    this.setState({ locale: getLocaleLanguage() });
  }


  handleLanguageChange = (e) => {
    this.setState({ locale: e.target.value });
    localStorage.setItem('laguagePrefered', e.target.value);
  };

  checkString(str1,str2)
  {
    return str1.includes(str2);
  }

  
  render() {
    function Loader() {
      return (
        <RotatingLines
          strokeColor="grey"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true} />
      )
    }
    
    if ((getToken() === "" || getToken() === null)) {
      return (<Navigate to="/" />);
    }
    if(!this.state.dataField && this.state.loading)
    {
      return(<div style={{display: 'flex',zIndex:'-moz-initial',height:'100vh',width:'100vw',justifyContent: 'center', alignItems: 'center'}}><Loader></Loader></div>)
    }
    else
    {
    return (
      <div className={`app ${this.state.loading ? 'blurred' : ''}`}>
      <IntlProvider locale={this.state.locale}
        messages={messages[this.state.locale]} defaultLocale="en" onError={(error) => { /* Handle missing message... */ }}>
        <div style={{ 'width': '100vw' }}>
          <HeaderMenu />
          
          <center style={{ marginTop: 20 }}> 
              
          <FormControl variant="standard" sx={{ m: 1, minWidth: 220 }}>
       
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={this.state.locale}
          onChange={this.handleLanguageChange}
          label="Language"
        >
          {options.map(option =>
              (
                 <MenuItem value={option.value} key={option.index}>{option.label}</MenuItem>
              )
            )
            }
          </Select>
      </FormControl>
          </center>
          <p/>
          <div style={{ 'padding': '10px', 'width':'100%', 'backgroundColor':'#3D74D5', 'color':'#FFF', 'fontWeight':'bolder'}}><big>Information</big></div>
          <p/>
          <div style={{ 'margin': '20px' }}>
	              <>
            <div>
              <p></p>
              
              <center>
    
              <>
     
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" style={{'padding':'20px','border':'1px #3D74D5 solid','text-align': 'left','backgroundColor':'#fff'}}>
                <a href="https://jpets.mhlw.go.jp/jp/" target="_blank" rel="noreferrer">Japan Pre-Entry Tuberculosis Screening (JPETS)</a>
                <p></p>
                {<FormattedMessage id="jpetswebsite" />}
                <p></p>
                </div>

                <p></p>
     

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" style={{'padding':'20px','border':'1px #3D74D5 solid','text-align': 'left','backgroundColor':'#fff'}}>
                   <a href="https://jata.or.jp/english/outline/organization/jpets/#information" target="_blank" rel="noreferrer">CJPQA JPETS Movies</a>
                <p></p>
              {<FormattedMessage id="cjpqajpetsmovies" />}
                  <p></p>

                </div>
               <p></p>
               
             
              
              </>
				
              </center>
             
            </div>
            </>  
          </div>

          
          <div className="footer">
            <p>© 2025 IOM. All rights reserved. version 1.0.0 </p>
          </div>
        </div>     </IntlProvider></div>);
    }
  }
}
//export default HomeCertificate;

export default addHookTo(Information);